// PTECRegistration.jsx
import React from "react";

export default function PTECRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            PTEC Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            PTEC Registration for Professionals
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides assistance for PTEC Registration for
            professionals and self-employed individuals, helping them meet
            state-level professional tax enrolment requirements where
            applicable.[web:274][web:277][web:279]
          </p>
          <p className="text-gray-700">
            The service focuses on determining applicability, preparing basic
            identity and business details, and completing state portal
            enrolment so that professional tax obligations are recognised and
            paid correctly.[web:274][web:277]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/6694871/pexels-photo-6694871.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Self-employed professional reviewing compliance documents"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for PTEC Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile the basic KYC and activity
              details that states generally ask for while issuing a PTEC
              certificate.[web:274][web:277][web:279]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN card of the individual professional or proprietorship,
                  as applicable.[web:274][web:277][web:282]
                </li>
                <li>
                  Identity proof such as Aadhaar card, voter ID, or passport,
                  often accepted as both ID and residence proof.[web:274][web:277]
                </li>
                <li>
                  Address proof of the place of work or business (utility bill,
                  rent agreement, property tax receipt, or similar).[web:274][web:277][web:282]
                </li>
                <li>
                  Basic details of the profession or activity and bank
                  information where the state portal requests these for
                  enrolment.[web:274][web:277]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm aims to simplify state-wise PTEC compliance so that
              professionals can focus on their practice while staying within
              professional tax norms.[web:274][web:279]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Professional Tax Laws
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on when PTEC applies, how it differs from employer
                  registration (PTRC), and how state rules treat various
                  professions and income levels.[web:274][web:280]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Transparent Registration Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Clear explanation of documents, steps, and timelines so that
                  applicants know how their PTEC application will move from
                  submission to certificate.[web:277][web:283]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional assistance with portal filing, follow-ups, and
                  basic payment or renewal guidance, providing a steady support
                  point for PTEC compliance.[web:274][web:279]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
